import { getSessions, initExpandableText, initPaginationButtons } from './helpers.js'

document.addEventListener("DOMContentLoaded", () => {
    const sessionBoards = document.querySelectorAll(".session-board");

    for (const sessionBoard of sessionBoards) {
        const form = sessionBoard.querySelector("form");
        const selects = form.querySelectorAll(".session-board__search__select");
        const searchInput = form.querySelector('input[name="s"]');
        let searchTimeout;

        initExpandableText();
        initPaginationButtons();

        for (const select of selects) {
            const btn = select.querySelector("button");

            const open = () => {
                const list = select.querySelector(".session-board__search__select__list");
                list.style.left = null;

                if ( list.getBoundingClientRect().left < 0 ) {
                    list.style.left = 0;
                }

                select.classList.add("active");
                setTimeout(() => document.addEventListener("click", closeOutSide));
            }

            const close = () => {
                select.classList.remove("active");
                document.removeEventListener("click", closeOutSide);
            }

            const closeOutSide = (e) => {
                if (!e.target.contains(select))
                    close();
            }

            btn.addEventListener("click", (e) => {
                e.preventDefault();
                if (select.classList.contains("active")) close();
                else open();
            })

            const radioInputs = select.querySelectorAll("input[type=radio]");
            radioInputs.forEach(radio => {
                radio.addEventListener("click", () => {
                    if (radio.dataset.wasChecked === "true") {
                        radio.checked = false;
                        radio.dataset.wasChecked = "false";
                        getSessions();
                        close();
                        return;
                    }
                    radioInputs.forEach(r => r.dataset.wasChecked = "false");
                    radio.dataset.wasChecked = "true";
                });
                radio.addEventListener("change", () => {
                    getSessions();
                    close();
                });
            });
        }

        const dayButtons = sessionBoard.querySelectorAll(".session-board__days__btn");
        const dayInput = form.querySelector("#session-day-filter");
        const dayPill = sessionBoard.querySelector(".session-board__days__pill");
        const dayTrack = sessionBoard.querySelector(".session-board__days__track");

        const movePill = (activeBtn) => {
            if (!dayPill || !dayTrack || !activeBtn) return;
            const trackRect = dayTrack.getBoundingClientRect();
            const btnRect = activeBtn.getBoundingClientRect();
            dayPill.style.left = (btnRect.left - trackRect.left) + "px";
            dayPill.style.width = btnRect.width + "px";
        };


        // Position pill on load without transition
        const initialActive = sessionBoard.querySelector(".session-board__days__btn.active");
        if (initialActive && dayPill) {
            dayPill.style.transition = "none";
            requestAnimationFrame(() => {
                movePill(initialActive);
                requestAnimationFrame(() => {
                    dayPill.style.transition = "";
                });
            });
        }

        dayButtons.forEach(btn => {
            btn.addEventListener("click", () => {
                dayButtons.forEach(b => b.classList.remove("active"));
                btn.classList.add("active");
                movePill(btn);
                sessionBoard.querySelector(".session-board__days").scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                if (dayInput) dayInput.value = btn.dataset.day;
                getSessions(1, false);
            });
        });

        const daysMobileSelect = sessionBoard.querySelector(".session-board__days__select");
        if (daysMobileSelect) {
            const mobileBtn = daysMobileSelect.querySelector("button");
            const mobileBtnLabel = mobileBtn.querySelector("span");

            const openDaySelect = () => {
                daysMobileSelect.classList.add("active");
                setTimeout(() => document.addEventListener("click", closeDaySelectOutside));
            };

            const closeDaySelect = () => {
                daysMobileSelect.classList.remove("active");
                document.removeEventListener("click", closeDaySelectOutside);
            };

            const closeDaySelectOutside = (e) => {
                if (!daysMobileSelect.contains(e.target)) closeDaySelect();
            };

            mobileBtn.addEventListener("click", (e) => {
                e.preventDefault();
                if (daysMobileSelect.classList.contains("active")) closeDaySelect();
                else openDaySelect();
            });

            const dayRadios = daysMobileSelect.querySelectorAll("input[type=radio]");
            dayRadios.forEach(radio => {
                radio.addEventListener("change", () => {
                    const label = daysMobileSelect.querySelector(`label[for="${radio.id}"]`);
                    if (label && mobileBtnLabel) mobileBtnLabel.textContent = label.textContent;
                    if (dayInput) dayInput.value = radio.value;
                    dayButtons.forEach(b => b.classList.toggle("active", b.dataset.day === radio.value));
                    const matchingBtn = sessionBoard.querySelector(`.session-board__days__btn[data-day="${radio.value}"]`);
                    if (matchingBtn) movePill(matchingBtn);
                    getSessions(1, false);
                    closeDaySelect();
                });
            });
        }

        let resizeTimer;
        window.addEventListener("resize", () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                const activeBtn = sessionBoard.querySelector(".session-board__days__btn.active");
                if (activeBtn) {
                    dayPill.style.transition = "none";
                    movePill(activeBtn);
                    requestAnimationFrame(() => { dayPill.style.transition = ""; });
                }
            }, 100);
        });

        if (searchInput) {
            searchInput.addEventListener("input", () => {
                clearTimeout(searchTimeout);
                searchTimeout = setTimeout(() => {
                    getSessions();
                }, 500);
            });
        }

        form.addEventListener("submit", (e) => {
            e.preventDefault();
            getSessions();
        });
    }
});